import { DropdownInfo } from "../../generic-sprites/DropDownMenu"
import { MakeFriendAudio } from "./MakeFriendAssets"

export enum StageTypes {
    ARCADE = "arcade",
    SLEEPOVER = "sleepover",
    POOL = "pool"
}

export type MakeFriendAttribute = MakeFriendFirstAttribute | MakeFriendSecondAttribute | MakeFriendThirdAttribute | MakeFriendFourthAttribute | MakeFriendFifthAttribute

export enum MakeFriendFirstAttribute {
    FRIENDLY = "friendly",
    TALKATIVE = "talkative",
    SOCIAL = "social",
    ENERGETIC = "energetic"
}

export enum MakeFriendSecondAttribute {
    CARING = "caring",
    KIND = "kind",
    GENEROUS = "generous",
    HELPFUL = "helpful"
}

export enum MakeFriendThirdAttribute {
    CAREFUL = "careful",
    HARDWORKING = "hardworking",
    HONEST = "honest",
    RESPONSIBLE = "responsible"
}

export enum MakeFriendFourthAttribute {
    FUNNY = "funny",
    QUIET = "quiet",
    HAPPY = "happy",
    EASYGOING = "easygoing"
}

export enum MakeFriendFifthAttribute {
    ARTISTIC = "artistic",
    CREATIVE = "creative",
    CURIOUS = "curious",
    SMART = "smart"
}

export const Attributes: Array<Array<DropdownInfo<MakeFriendAttribute>>> = [
    [
        {text: MakeFriendFirstAttribute.FRIENDLY, audio: MakeFriendAudio.ATTRIBUTE_FRIENDLY},
        {text: MakeFriendFirstAttribute.TALKATIVE, audio: MakeFriendAudio.ATTRIBUTE_TALKATIVE},
        {text: MakeFriendFirstAttribute.SOCIAL, audio: MakeFriendAudio.ATTRIBUTE_SOCIAL},
        {text: MakeFriendFirstAttribute.ENERGETIC, audio: MakeFriendAudio.ATTRIBUTE_ENERGETIC}
    ],
    [
        {text: MakeFriendSecondAttribute.CARING, audio: MakeFriendAudio.ATTRIBUTE_CARING},
        {text: MakeFriendSecondAttribute.KIND, audio: MakeFriendAudio.ATTRIBUTE_KIND},
        {text: MakeFriendSecondAttribute.GENEROUS, audio: MakeFriendAudio.ATTRIBUTE_GENEROUS},
        {text: MakeFriendSecondAttribute.HELPFUL, audio: MakeFriendAudio.ATTRIBUTE_HELPFUL}
    ],
    [
        {text: MakeFriendThirdAttribute.CAREFUL, audio: MakeFriendAudio.ATTRIBUTE_CAREFUL},
        {text: MakeFriendThirdAttribute.HARDWORKING, audio: MakeFriendAudio.ATTRIBUTE_HARDWORKING},
        {text: MakeFriendThirdAttribute.HONEST, audio: MakeFriendAudio.ATTRIBUTE_HONEST},
        {text: MakeFriendThirdAttribute.RESPONSIBLE, audio: MakeFriendAudio.ATTRIBUTE_RESPONSIBLE}
    ],
    [
        {text: MakeFriendFourthAttribute.FUNNY, audio: MakeFriendAudio.ATTRIBUTE_FUNNY},
        {text: MakeFriendFourthAttribute.QUIET, audio: MakeFriendAudio.ATTRIBUTE_QUIET},
        {text: MakeFriendFourthAttribute.HAPPY, audio: MakeFriendAudio.ATTRIBUTE_HAPPY},
        {text: MakeFriendFourthAttribute.EASYGOING, audio: MakeFriendAudio.ATTRIBUTE_EASYGOING}
    ],
    [
        {text: MakeFriendFifthAttribute.ARTISTIC, audio: MakeFriendAudio.ATTRIBUTE_ARTISTIC},
        {text: MakeFriendFifthAttribute.CREATIVE, audio: MakeFriendAudio.ATTRIBUTE_CREATIVE},
        {text: MakeFriendFifthAttribute.CURIOUS, audio: MakeFriendAudio.ATTRIBUTE_CURIOUS},
        {text: MakeFriendFifthAttribute.SMART, audio: MakeFriendAudio.ATTRIBUTE_SMART}
    ]
]